const baseUrl = 'https://api-secrets.herokuapp.com/api/';

export const loginURL = baseUrl + 'login';

export const signupURL = baseUrl + 'register';

export const secretsURL = baseUrl + 'secrets';

export const verifyAuthURL = baseUrl + 'verify';

export const logoutURL = baseUrl + 'logout';
